import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server} from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class ClientContractPackageService {
  constructor(private http:HttpClient) { }
  createManyForAClientContract(clientContractId,postData){
    return this.http.post<any[]>(`${server}clientcontractpackages/clientcontract/${clientContractId}`,postData);
  }
  findOne(_id){
    return this.http.get<any>(`${server}clientcontractpackages/${_id}`);
  }
  findAllForAClientContract(clientContractId){
    return this.http.get<any[]>(`${server}clientcontractpackages/clientcontract/${clientContractId}`);
  }
  findAllWithoutFileUpoadForAClientContract(clientContractId){
    return this.http.get<any[]>(`${server}clientcontractpackages/clientcontract/${clientContractId}/withoutfileupload`);
  }
  deleteAllForAClientContract(clientContractId){
    return this.http.delete(`${server}clientcontractpackages/clientcontract/${clientContractId}`);
  }  
  getClientContractPackageDetails(apackage){
    return this.http.get<any>(`${server}cdecase/getcdecasepackagedetails/${apackage}`);
  } 
  getClientContractComponentsDetails(alacart){
    return this.http.get<any>(`${server}cdecase/getcdecasealacartdetails/${alacart}`);
  }
}
